import types from './types';
import API from '../../lib/api';
import {toast} from 'react-toastify';

export const loadTournament = () => async dispatch => {
    const response = await API.call({
        path: '/tournaments/get'
    });

    if(response.success)
        dispatch({
            type: types.loaded,
            payload: response.data
        }); 
}

export const unload = () => {
    return {
        type: types.unload
    }
}